module.exports = __webpack_public_path__ + "static/img/wxpay.1b369a8a.png";